import React, { useEffect, useMemo, useState } from "react";
import Header from "./HostelHeader";
import Nav from "../master/NavBar";
import Footer from "../main/footer";
import { SweetAlertShow, LoadingDiv, closeModal } from "../master/Master";
import {
  GetHostelList,
  HostelBedsList,
  HostelRoomList,
  HostelStudentCreate,
} from "../../api/HostelService";
import Swal from "sweetalert2";
import { useNavigate, useSearchParams } from "react-router-dom";
import WelcomeBar from "./WelcomeBar";
import { batchDetailsWithStudents, batchList } from "../../api/Batch";
import { hostelStudentList } from "../../api/Student";
import { formatToDate } from "../master/FormatToDateTime";
import { imgBaseUrl } from "../../api/api";
import { messList } from "../../api/Mess";

export default function StudentAdd() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const studentIdFromUrl = searchParams.get("student_id");
  const batchIdFromUrl = searchParams.get("batch_id");
  const hostelIdFromUrl = searchParams.get("hostel_id");

  const [loading, setLoading] = useState(false);
  const [hostels, setHostels] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [beds, setBeds] = useState([]);
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [hostelUnassignStudents, setHostelUnassignStudents] = useState([]);

  const [bedData, setBedData] = useState({});
  const [studentSearch, setStudentSearch] = useState("");

  const [messListData, setMessListData] = useState([]);
  const [addToMess, setAddToMess] = useState(false);
  const [selectedMessId, setSelectedMessId] = useState("");

  const [data, setData] = useState({
    hostel_id: hostelIdFromUrl || localStorage.getItem("hostel_id") || "",
    batch_id: "",
    student_id: "",
    name: "",
    registration_no: "",
    father_name: "",
    phone: "",
    aadhar: "",
    admission_date: "",
    address: "",
    end_date: "",
    imgUrl: "",
  });

  useEffect(() => {
    if (hostelIdFromUrl) {
      setData((prev) => ({
        ...prev,
        hostel_id: hostelIdFromUrl,
      }));
    }
  }, [hostelIdFromUrl]);

  useEffect(() => {
    const handleStorageChange = () => {
      if (!hostelIdFromUrl) {
        setData((prev) => ({
          ...prev,
          hostel_id: localStorage.getItem("hostel_id") || "",
        }));
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [hostelIdFromUrl]);

  const updateData = (field, value) => {
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getStudentImage = (image) => {
    if (!image) return "";

    if (image.startsWith("http://") || image.startsWith("https://")) {
      return image;
    }

    return `${imgBaseUrl.replace(/\/$/, "")}/${image.replace(/^\//, "")}`;
  };

  const getStudentAddress = (student) => {
    return `${student?.village ?? ""}${
      student?.district ? `, ${student.district}` : ""
    }${student?.state ? `, ${student.state}` : ""}${
      student?.zipcode ? ` - ${student.zipcode}` : ""
    }`;
  };

  const hasSelectedStudent = Boolean(data?.student_id);

  const selectedRoom = useMemo(() => {
    const roomId = document.querySelector('select[name="room_id"]')?.value;

    return rooms?.data?.find((room) => String(room?.id) === String(roomId));
  }, [rooms]);

  const getHostelList = async () => {
    setLoading(true);
    let addUrl = "";
    if (data?.hostel_id) {
      addUrl += `&hostel_id=${data.hostel_id}`;
    }
    try {
      const response = await GetHostelList(addUrl);
      if (response.data?.status) {
        setHostels(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getHostelRoomsList = async (id) => {
    if (!id) return;
    setLoading(true);

    const addUrl = `&hostel_id=${id}&status=Vacant`;

    try {
      const response = await HostelRoomList(addUrl);
      if (response.data?.status) {
        setRooms(response?.data?.data);

        if (response?.data?.data?.total == "0") {
          Swal.fire({
            title: "Rooms not found!",
            text: "Please add rooms.",
            icon: "warning",
            confirmButtonText: "Go to Rooms",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/hostel/rooms");
            }
          });
        }
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getHostelBedsList = async (roomId) => {
    if (!roomId) {
      setBeds([]);
      setBedData({});
      return;
    }
    setLoading(true);

    let addUrl = `&room_id=${roomId}&status=Vacant`;

    if (data?.hostel_id) {
      addUrl += `&hostel_id=${data.hostel_id}`;
    }

    try {
      const response = await HostelBedsList(addUrl);

      if (response.data?.status) {
        const bedsList = response?.data?.data?.data || [];

        setBeds(response?.data?.data);

        if (bedsList.length === 0) {
          Swal.fire({
            title: "Beds not found!",
            text: "Please add beds.",
            icon: "warning",
            confirmButtonText: "Go to Beds",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/hostel/rooms");
            }
          });
        }
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchesList = async () => {
    setLoading(true);

    try {
      const response = await batchList();

      if (response.data?.status) {
        setBatches(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchStudents = async (id) => {
    if (!id) {
      setStudents([]);
      return;
    }
    setLoading(true);

    try {
      const addUrl = `id=${id}`;

      const response = await batchDetailsWithStudents(addUrl);

      if (response.data?.status) {
        setStudents(response?.data?.data?.active_batch_students || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getHostelUnassignStudents = async (search = "") => {
    setLoading(true);

    try {
      let addUrl = "hostel_status=unassign";

      if (search?.trim()) {
        addUrl = `search=${encodeURIComponent(search.trim())}`;
      }

      const response = await hostelStudentList(addUrl);

      if (response.data?.status) {
        setHostelUnassignStudents(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatchesList();
    getHostelUnassignStudents();
    getMessList();
  }, []);

  useEffect(() => {
    if (data?.hostel_id) {
      getHostelRoomsList(data.hostel_id);
    }
  }, [data?.hostel_id]);

  useEffect(() => {
    if (!batchIdFromUrl) return;

    const batchId = String(batchIdFromUrl);

    setData((prev) => ({
      ...prev,
      batch_id: batchId,
    }));

    getBatchStudents(batchId);
  }, [batchIdFromUrl]);

  useEffect(() => {
    if (!studentIdFromUrl || !batchIdFromUrl || !students?.length) {
      return;
    }

    const studentId = String(studentIdFromUrl);

    const selectedStudentRow = students.find(
      (student) => String(student?.student_info?.id) === studentId,
    );

    if (!selectedStudentRow?.student_info) {
      return;
    }

    const selectedStudent = selectedStudentRow.student_info;

    setData((prev) => ({
      ...prev,
      batch_id: String(batchIdFromUrl),
      student_id: selectedStudent?.id || studentId,
      name: selectedStudent?.name || "",
      registration_no: selectedStudent?.registration_no || "",
      father_name: selectedStudent?.father_name || "",
      phone: selectedStudent?.phone || "",
      aadhar: selectedStudent?.aadhar || "",
      admission_date: selectedStudent?.admission_date || "",
      imgUrl:
        selectedStudent?.profile_picture ||
        selectedStudent?.imgUrl ||
        selectedStudent?.profile_image ||
        "",
      address: getStudentAddress(selectedStudent),
    }));
  }, [students, studentIdFromUrl, batchIdFromUrl]);

  const selectStudent = (student) => {
    const batch = student?.latest_course_and_fee?.batch;

    setData((prev) => ({
      ...prev,
      batch_id: batch?.id || "",
      student_id: student?.id || "",
      name: student?.name || "",
      registration_no: student?.registration_no || "",
      father_name: student?.father_name || "",
      phone: student?.phone || "",
      aadhar: student?.aadhar || "",
      admission_date: student?.admission_date || "",
      imgUrl: student?.profile_picture || "",
      address: getStudentAddress(student),
    }));

    setBedData({});
    setBeds([]);
    setAddToMess(false);
    setSelectedMessId("");

    if (batch?.id) {
      getBatchStudents(batch.id);
    }

    setStudentSearch("");

    closeModal("studentSelectionModal");
  };
  const handleBatchChange = (e) => {
    const batchId = e.target.value;

    setData((prev) => ({
      ...prev,
      batch_id: batchId,
      student_id: "",
      name: "",
      registration_no: "",
      father_name: "",
      phone: "",
      aadhar: "",
      admission_date: "",
      address: "",
      imgUrl: "",
    }));

    setAddToMess(false);
    setSelectedMessId("");

    setStudents([]);
    setBedData({});
    setBeds([]);

    if (batchId) {
      getBatchStudents(batchId);
    }
  };

  const handleStudentChange = (e) => {
    const studentId = e.target.value;

    const selectedStudent = students?.find(
      (student) => String(student?.student_info?.id) === String(studentId),
    )?.student_info;

    if (!selectedStudent) return;

    setData((prev) => ({
      ...prev,
      student_id: studentId,
      name: selectedStudent?.name || "",
      registration_no: selectedStudent?.registration_no || "",
      father_name: selectedStudent?.father_name || "",
      phone: selectedStudent?.phone || "",
      aadhar: selectedStudent?.aadhar || "",
      admission_date: selectedStudent?.admission_date || "",
      imgUrl:
        selectedStudent?.profile_picture ||
        selectedStudent?.imgUrl ||
        selectedStudent?.profile_image ||
        "",
      address: getStudentAddress(selectedStudent),
    }));
  };

  const handleRoomChange = (e) => {
    const roomId = e.target.value;

    setBedData({});
    setBeds([]);

    if (roomId) {
      getHostelBedsList(roomId);
    }
  };

  const handleBedChange = (e) => {
    const selectedBed = beds?.data?.find(
      (bed) => String(bed?.id) === String(e.target.value),
    );

    setBedData(selectedBed || {});
  };

  const getMessList = async () => {
    try {
      const response = await messList();

      if (response?.data?.status) {
        const messData = response?.data?.data;

        // Handle both:
        // 1. data: [...]
        // 2. data: { data: [...] }
        const list = Array.isArray(messData)
          ? messData
          : Array.isArray(messData?.data)
            ? messData.data
            : [];

        setMessListData(list);
      } else {
        setMessListData([]);

        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to load mess list.",
        );
      }
    } catch (error) {
      setMessListData([]);

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    }
  };

  const createHostelStudent = async (e) => {
    e.preventDefault();
    if (!data?.student_id) {
      SweetAlertShow("warning", "Student Required", "Please select a student.");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await HostelStudentCreate(formData);

      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
        navigate("/hostel/students");
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid">
                <WelcomeBar />

                <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mt-4 mb-4">
                  <div>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <div className="avatar avatar-sm">
                        <span className="avatar-initial rounded bg-label-primary">
                          <i className="ri-home-5-line" />
                        </span>
                      </div>

                      <h4 className="mb-0">Add Student to Hostel</h4>
                    </div>

                    <p className="text-muted mb-0">
                      Select a student, verify their details and assign a room
                      and bed.
                    </p>
                  </div>

                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#studentSelectionModal"
                    onClick={() => {
                      setStudentSearch("");
                      getHostelUnassignStudents();
                    }}
                  >
                    <i className="ri-user-search-line me-1" />
                    Find Student
                  </button>
                </div>

                <form onSubmit={createHostelStudent}>
                  {/* =====================================================
                      STEP 1 — SELECT STUDENT
                  ====================================================== */}
                  <div className="card mb-4">
                    <div className="card-header border-bottom">
                      <div className="d-flex align-items-center gap-3">
                        <div className="avatar avatar-sm">
                          <span className="avatar-initial rounded bg-label-primary">
                            1
                          </span>
                        </div>

                        <div>
                          <h5 className="mb-0">Select Student</h5>
                          <small className="text-muted">
                            Choose the batch and student to add to the hostel.
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="card-body pt-4">
                      <input
                        type="hidden"
                        name="hostel_id"
                        value={data?.hostel_id || ""}
                      />

                      <div className="row g-4">
                        {/* BATCH */}

                        <div className="col-lg-6">
                          <div className="form-floating form-floating-outline">
                            <select
                              className="form-select"
                              id="batch_id"
                              name="batch_id"
                              value={data?.batch_id || ""}
                              onChange={handleBatchChange}
                              required
                            >
                              <option value="">Select Batch</option>

                              {batches?.map((batch) => (
                                <option key={batch?.id} value={batch?.id}>
                                  {batch?.title}
                                  {batch?.course?.title
                                    ? ` (${batch.course.title})`
                                    : ""}
                                </option>
                              ))}
                            </select>

                            <label htmlFor="batch_id">Batch</label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="d-flex gap-2">
                            <div className="form-floating form-floating-outline flex-grow-1">
                              <select
                                className="form-select"
                                name="student_id"
                                value={data?.student_id || ""}
                                onChange={handleStudentChange}
                                disabled={!data?.batch_id}
                                required
                              >
                                <option value="">
                                  {!data?.batch_id
                                    ? "Select batch first"
                                    : "Select Student"}
                                </option>

                                {students?.map((student) => (
                                  <option
                                    key={student?.student_info?.id}
                                    value={student?.student_info?.id}
                                  >
                                    {student?.student_info?.name} (
                                    {student?.student_info?.registration_no})
                                  </option>
                                ))}
                              </select>

                              <label>Student</label>
                            </div>

                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{
                                minWidth: 48,
                                height: 48,
                                marginTop: 2,
                              }}
                              title="Find Student"
                              data-bs-toggle="modal"
                              data-bs-target="#studentSelectionModal"
                              onClick={() => {
                                setStudentSearch("");
                                getHostelUnassignStudents();
                              }}
                            >
                              <i className="ri-search-line" />
                            </button>
                          </div>

                          {!data?.batch_id && (
                            <small className="text-muted d-block mt-2">
                              Choose a batch to load its students.
                            </small>
                          )}
                        </div>
                      </div>

                      {hasSelectedStudent && (
                        <div className="mt-4">
                          <div className="border rounded p-3 bg-label-primary-subtle">
                            <div className="d-flex align-items-center gap-3">
                              <div
                                className="rounded-circle overflow-hidden border flex-shrink-0"
                                style={{
                                  width: 52,
                                  height: 52,
                                }}
                              >
                                {data?.imgUrl ? (
                                  <img
                                    src={getStudentImage(data.imgUrl)}
                                    alt={data?.name || "Student"}
                                    className="w-100 h-100 object-fit-cover"
                                    onError={(e) => {
                                      e.currentTarget.style.display = "none";
                                      e.currentTarget.nextElementSibling.style.display =
                                        "flex";
                                    }}
                                  />
                                ) : null}

                                <div
                                  className="w-100 h-100 align-items-center justify-content-center bg-label-secondary"
                                  style={{
                                    display: data?.imgUrl ? "none" : "flex",
                                  }}
                                >
                                  <i className="ri-user-3-line ri-24px" />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex flex-wrap align-items-center gap-2">
                                  <span className="fw-semibold">
                                    {data?.name}
                                  </span>

                                  {data?.registration_no && (
                                    <span className="badge bg-label-primary">
                                      {data.registration_no}
                                    </span>
                                  )}
                                </div>

                                <small className="text-muted">
                                  Student selected. Verify the information below
                                  before assigning accommodation.
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* =====================================================
                      STEP 2 — STUDENT INFORMATION
                  ====================================================== */}

                  <div
                    className={`card mb-4 ${
                      !hasSelectedStudent ? "opacity-75" : ""
                    }`}
                  >
                    <div className="card-header border-bottom">
                      <div className="d-flex align-items-center gap-3">
                        <div className="avatar avatar-sm">
                          <span className="avatar-initial rounded bg-label-primary">
                            2
                          </span>
                        </div>

                        <div className="flex-grow-1">
                          <h5 className="mb-0">Student Information</h5>

                          <small className="text-muted">
                            Information is pre-filled from the student record.
                            You can edit it directly before admission.
                          </small>
                        </div>

                        {hasSelectedStudent && (
                          <span className="badge bg-label-success">
                            <i className="ri-check-line me-1" />
                            Ready
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="card-body pt-4">
                      {!hasSelectedStudent ? (
                        <div className="text-center py-4">
                          <div className="avatar avatar-md mx-auto mb-3">
                            <span className="avatar-initial rounded bg-label-secondary">
                              <i className="ri-user-search-line ri-24px" />
                            </span>
                          </div>

                          <h6 className="mb-1">Select a student first</h6>

                          <p className="text-muted mb-0">
                            Student information will appear here after
                            selection.
                          </p>
                        </div>
                      ) : (
                        <>
                          {/* Hidden student values */}

                          <input
                            type="hidden"
                            name="student_name"
                            value={data?.name || ""}
                          />

                          <input
                            type="hidden"
                            name="registration_no"
                            value={data?.registration_no || ""}
                          />

                          <input
                            type="hidden"
                            name="father_name"
                            value={data?.father_name || ""}
                          />

                          <input
                            type="hidden"
                            name="mobile"
                            value={data?.phone || ""}
                          />

                          <input
                            type="hidden"
                            name="aadhar_no"
                            value={data?.aadhar || ""}
                          />

                          <input
                            type="hidden"
                            name="joining_date"
                            value={data?.admission_date || ""}
                          />

                          <input
                            type="hidden"
                            name="address"
                            value={data?.address || ""}
                          />

                          <div className="row g-4">
                            {/* STUDENT NAME */}

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-capitalize"
                                  placeholder="Student Name"
                                  name="student_name_display"
                                  value={data?.name || ""}
                                  onChange={(e) =>
                                    updateData("name", e.target.value)
                                  }
                                  required
                                />

                                <label>Student Name</label>
                              </div>
                            </div>

                            {/* REGISTRATION */}

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Registration No"
                                  name="registration_no_display"
                                  value={data?.registration_no || ""}
                                  onChange={(e) =>
                                    updateData(
                                      "registration_no",
                                      e.target.value,
                                    )
                                  }
                                />

                                <label>Registration No.</label>
                              </div>
                            </div>

                            {/* FATHER */}

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-uppercase"
                                  placeholder="Father Name"
                                  name="father_name_display"
                                  value={data?.father_name || ""}
                                  onChange={(e) =>
                                    updateData("father_name", e.target.value)
                                  }
                                />

                                <label>Father Name</label>
                              </div>
                            </div>

                            {/* MOBILE */}

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Mobile"
                                  name="mobile_display"
                                  value={data?.phone || ""}
                                  onChange={(e) =>
                                    updateData("phone", e.target.value)
                                  }
                                  required
                                />

                                <label>Mobile</label>
                              </div>
                            </div>

                            {/* AADHAAR */}

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Aadhaar No"
                                  name="aadhar_no_display"
                                  maxLength={12}
                                  minLength={12}
                                  value={data?.aadhar || ""}
                                  onChange={(e) =>
                                    updateData(
                                      "aadhar",
                                      e.target.value.replace(/\D/g, ""),
                                    )
                                  }
                                />

                                <label>Aadhaar No.</label>
                              </div>
                            </div>

                            {/* JOINING DATE */}

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="date"
                                  className="form-control"
                                  name="joining_date"
                                  required
                                  value={data?.admission_date || ""}
                                  onChange={(e) =>
                                    updateData("admission_date", e.target.value)
                                  }
                                />

                                <label>Joining Date</label>
                              </div>

                              <small className="text-muted d-block mt-2">
                                <i className="ri-information-line me-1" />
                                Pre-filled from the student's admission date.
                                You can change it if the hostel joining date is
                                different.
                              </small>
                            </div>

                            {/* ADDRESS */}

                            <div className="col-12">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  className="form-control input-uppercase"
                                  placeholder="Address"
                                  name="address_display"
                                  style={{
                                    minHeight: "95px",
                                  }}
                                  value={data?.address || ""}
                                  onChange={(e) =>
                                    updateData("address", e.target.value)
                                  }
                                />

                                <label>Address</label>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* =====================================================
                      STEP 3 — HOSTEL ALLOCATION
                  ====================================================== */}

                  <div
                    className={`card mb-4 ${
                      !hasSelectedStudent ? "opacity-75" : ""
                    }`}
                  >
                    <div className="card-header border-bottom">
                      <div className="d-flex align-items-center gap-3">
                        <div className="avatar avatar-sm">
                          <span className="avatar-initial rounded bg-label-primary">
                            3
                          </span>
                        </div>

                        <div>
                          <h5 className="mb-0">Hostel Allocation</h5>

                          <small className="text-muted">
                            Assign the student's room, bed and fee details.
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="card-body pt-4">
                      <div className="row g-4">
                        {/* ROOM */}
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline">
                            <select
                              name="room_id"
                              className="form-select"
                              required
                              defaultValue=""
                              disabled={!hasSelectedStudent}
                              onChange={handleRoomChange}
                            >
                              <option value="">Select Room</option>

                              {rooms?.data?.map((room) => (
                                <option key={room?.id} value={room?.id}>
                                  Room {room?.room_no}
                                </option>
                              ))}
                            </select>

                            <label>Room</label>
                          </div>
                        </div>

                        {/* BED */}
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline">
                            <select
                              name="bed_id"
                              className="form-select"
                              required
                              defaultValue=""
                              disabled={
                                !hasSelectedStudent || !beds?.data?.length
                              }
                              onChange={handleBedChange}
                            >
                              <option value="">
                                {!hasSelectedStudent
                                  ? "Select student first"
                                  : !beds?.data?.length
                                    ? "Select room first"
                                    : "Select Bed"}
                              </option>

                              {beds?.data?.map((bed) => (
                                <option key={bed?.id} value={bed?.id}>
                                  {bed?.bed_no}
                                  {bed?.bed_charge
                                    ? ` (₹${bed.bed_charge})`
                                    : ""}
                                </option>
                              ))}
                            </select>

                            <label>Bed</label>
                          </div>
                        </div>

                        {/* BED CHARGE */}
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline">
                            <input
                              className="form-control"
                              type="number"
                              min="0"
                              step="0.01"
                              placeholder="Bed Charge"
                              name="final_fee"
                              defaultValue={bedData?.bed_charge || ""}
                              key={bedData?.id || "empty-bed"}
                              required
                              disabled={!hasSelectedStudent}
                            />

                            <label>Bed Charge</label>
                          </div>
                          {bedData?.bed_charge && (
                            <small className="text-muted d-block mt-2">
                              <i className="ri-information-line me-1" />
                              Default charge for selected bed: ₹
                              {bedData.bed_charge}
                            </small>
                          )}
                        </div>

                        {/* FEE TYPE */}
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline">
                            <select
                              name="fee_type"
                              className="form-select"
                              required
                              defaultValue=""
                              disabled={!hasSelectedStudent}
                            >
                              <option disabled value="">
                                Select Fee Type
                              </option>

                              <option value="Monthly">Monthly</option>

                              <option value="Full">Full</option>
                            </select>

                            <label>Fee Type</label>
                          </div>
                        </div>

                        {/* END DATE */}
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline">
                            <input
                              type="date"
                              className="form-control"
                              name="end_date"
                              min={new Date().toISOString().split("T")[0]}
                              value={data?.end_date || ""}
                              disabled={!hasSelectedStudent}
                              onChange={(e) =>
                                updateData("end_date", e.target.value)
                              }
                            />

                            <label>
                              End Date{" "}
                              <span className="text-muted">(Optional)</span>
                            </label>
                          </div>
                        </div>

                        {/* MESS */}
                        <div className="col-md-6">
                          <div className="border rounded p-3 h-100">
                            <div className="form-check mb-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="1"
                                id="mess_in_add"
                                name="mess_in_add"
                                checked={addToMess}
                                disabled={!hasSelectedStudent}
                                onChange={(e) => {
                                  const checked = e.target.checked;

                                  setAddToMess(checked);

                                  if (!checked) {
                                    setSelectedMessId("");
                                  }
                                }}
                              />

                              <label
                                className="form-check-label"
                                htmlFor="mess_in_add"
                              >
                                <span className="fw-medium d-block">
                                  Add to Mess
                                </span>

                                <small className="text-muted">
                                  Include this student in hostel mess
                                  allocation.
                                </small>
                              </label>
                            </div>

                            {addToMess && (
                              <div className="form-floating form-floating-outline mt-3">
                                <select
                                  className="form-select"
                                  id="mess_id"
                                  name="mess_id"
                                  value={selectedMessId}
                                  onChange={(e) =>
                                    setSelectedMessId(e.target.value)
                                  }
                                  required={addToMess}
                                >
                                  <option value="">Select Mess</option>

                                  {messListData?.map((mess) => (
                                    <option key={mess?.id} value={mess?.id}>
                                      {mess?.name}
                                    </option>
                                  ))}
                                </select>

                                <label htmlFor="mess_id">Mess</label>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* BED SUMMARY */}

                      {bedData?.id && (
                        <div className="mt-4">
                          <div className="border rounded p-3">
                            <div className="d-flex align-items-center gap-3">
                              <div className="avatar avatar-sm">
                                <span className="avatar-initial rounded bg-label-success">
                                  <i className="ri-hotel-bed-line" />
                                </span>
                              </div>

                              <div className="flex-grow-1">
                                <small className="text-muted d-block">
                                  Selected Bed
                                </small>

                                <span className="fw-semibold">
                                  {bedData?.bed_no}
                                </span>
                              </div>

                              <div className="text-end">
                                <small className="text-muted d-block">
                                  Default Charge
                                </small>

                                <span className="fw-semibold">
                                  ₹{bedData?.bed_charge || 0}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* =====================================================
                      FINAL SUBMIT
                  ====================================================== */}
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div className="avatar avatar-sm">
                            <span
                              className={`avatar-initial rounded ${
                                hasSelectedStudent
                                  ? "bg-label-success"
                                  : "bg-label-secondary"
                              }`}
                            >
                              <i
                                className={
                                  hasSelectedStudent
                                    ? "ri-check-line"
                                    : "ri-information-line"
                                }
                              />
                            </span>
                          </div>

                          <div>
                            <h6 className="mb-1">
                              {hasSelectedStudent
                                ? "Ready to add student"
                                : "Select a student to continue"}
                            </h6>

                            <small className="text-muted">
                              {hasSelectedStudent
                                ? "Review the joining date, room, bed and fee before submitting."
                                : "Select a student above to enable hostel allocation."}
                            </small>
                          </div>
                        </div>
                        <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => navigate("/hostel/students")}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="btn btn-primary px-4"
                            disabled={loading || !hasSelectedStudent}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                />
                                Adding...
                              </>
                            ) : (
                              <>
                                <i className="ri-user-add-line me-1" />
                                Add to Hostel
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>

      {/* ===============================================================
          STUDENT SELECTION MODAL
      ================================================================ */}
      <div
        className="modal fade"
        id="studentSelectionModal"
        tabIndex={-1}
        aria-labelledby="studentSelectionModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5
                  className="modal-title mb-1"
                  id="studentSelectionModalLabel"
                >
                  Find Student
                </h5>

                <small className="text-muted">
                  Search for a student who has not yet been assigned to a
                  hostel.
                </small>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              {/* SEARCH */}
              <div className="mb-4">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="ri-search-line" />
                  </span>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by student name, registration number or mobile..."
                    value={studentSearch}
                    onChange={(e) => {
                      const value = e.target.value;

                      setStudentSearch(value);
                      getHostelUnassignStudents(value);
                    }}
                    autoFocus
                  />
                </div>
              </div>

              {/* STUDENT LIST */}
              <div className="row g-3">
                {hostelUnassignStudents?.length > 0 ? (
                  hostelUnassignStudents.map((student, i) => {
                    const studentImage =
                      student?.profile_picture ||
                      student?.imgUrl ||
                      student?.profile_image;

                    const studentBatch = student?.latest_course_and_fee?.batch;

                    return (
                      <div className="col-12" key={student?.id || i}>
                        <div className="border rounded p-3">
                          <div className="d-flex flex-wrap align-items-center gap-3">
                            {/* IMAGE */}

                            <div
                              className="rounded-circle overflow-hidden border flex-shrink-0"
                              style={{
                                width: 58,
                                height: 58,
                              }}
                            >
                              {studentImage ? (
                                <img
                                  src={getStudentImage(studentImage)}
                                  alt={student?.name || "Student"}
                                  className="w-100 h-100 object-fit-cover"
                                  onError={(e) => {
                                    e.currentTarget.style.display = "none";

                                    e.currentTarget.nextElementSibling.style.display =
                                      "flex";
                                  }}
                                />
                              ) : null}

                              <div
                                className="w-100 h-100 align-items-center justify-content-center bg-label-secondary"
                                style={{
                                  display: studentImage ? "none" : "flex",
                                }}
                              >
                                <i className="ri-user-3-line ri-24px" />
                              </div>
                            </div>

                            {/* INFO */}

                            <div className="flex-grow-1">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                <h6 className="mb-0">{student?.name}</h6>

                                {student?.registration_no && (
                                  <span className="badge bg-label-primary">
                                    {student.registration_no}
                                  </span>
                                )}
                              </div>

                              <div className="d-flex flex-wrap gap-3 mt-2 small text-muted">
                                {student?.phone && (
                                  <span>
                                    <i className="ri-phone-line me-1" />
                                    {student.phone}
                                  </span>
                                )}

                                {student?.admission_date && (
                                  <span>
                                    <i className="ri-calendar-line me-1" />
                                    {formatToDate(student.admission_date)}
                                  </span>
                                )}

                                {studentBatch?.title && (
                                  <span>
                                    <i className="ri-bookmark-line me-1" />
                                    {studentBatch.title}
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* ACTION */}

                            <button
                              type="button"
                              className="btn btn-primary btn-sm px-3"
                              onClick={() => selectStudent(student)}
                            >
                              <i className="ri-user-add-line me-1" />
                              Select
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="col-12">
                    <div className="text-center py-5">
                      <div className="avatar avatar-lg mx-auto mb-3">
                        <span className="avatar-initial rounded bg-label-secondary">
                          <i className="ri-user-search-line ri-24px" />
                        </span>
                      </div>

                      <h6>
                        {studentSearch
                          ? "No matching students found"
                          : "No unassigned students found"}
                      </h6>

                      <p className="text-muted mb-0">
                        Try another name, registration number or mobile number.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
